export default {
  'stockCorrections.domain.company': 'Company',
  'stockCorrections.domain.employee': 'Employee',
  'stockCorrections.domain.date': 'Date',
  'stockCorrections.domain.observation': 'Observation',
  'stockCorrections.domain.items': 'Items',
  'stockCorrections.domain.items.itemName': 'Nome',
  'stockCorrections.domain.items.type': 'Type',
  'stockCorrections.domain.items.type.item_type.part': 'Part',
  'stockCorrections.domain.items.type.item_type.consumable': 'Consumable',
  'stockCorrections.domain.items.availableStock': 'Available',
  'stockCorrections.domain.items.reserved': 'Reserved',
  'stockCorrections.domain.items.stock': 'Stock',
  'stockCorrections.domain.items.originalCode': 'Original Code',
  'stockCorrections.domain.items.oldQuantity': 'Old Quantity',
  'stockCorrections.domain.items.newQuantity': 'New Quantity',
  'stockCorrections.domain.items.deltaQuantity': 'Delta Quantity',

  'stockCorrections.domain.items.add': 'Add Item',
  'stockCorrections.domain.items.add.emptyCompanyError': 'Error',
  'stockCorrections.domain.items.add.emptyCompanyErrorDescription':
    'Please select a company before adding items',

  'stockCorrections.create': 'Create Stock Correction',
  'stockCorrections.create.alert': 'Attention',
  'stockCorrections.create.alert.description':
    'Do you really want to send this stock correction? This action is irreversible.',
  'stockCorrections.create.notification.success': 'Success',
  'stockCorrections.create.notification.successDescription':
    'Stock Correction created.',
  'stockCorrections.create.errors.atLeastOneItem':
    'There should be at least 1 item in the stock correction.',

  'stockCorrections.create.items.search': 'Search the Items',
  'stockCorrections.create.items.searchMessage':
    'Filter and select the items to be added to the stock correction.',

  'stockCorrections.create.items.searchConfirm': 'Confirm',
  'stockCorrections.create.items.searchConfirmMessage':
    'Check the items to be added.',

  'stockCorrections.details': 'Stock Correction Details',

  'stockCorrections.update': 'Update Stock Correction',
  'stockCorrections.update.notification.success': 'Success',
  'stockCorrections.update.notification.successDescription':
    'Stock Correction updated.',

  'stockCorrections.remove': 'Remove Stock Correction',
  'stockCorrections.remove.alert':
    'Do you really want to remove the Stock Correction:',
  'stockCorrections.remove.notification.success': 'Success',
  'stockCorrections.remove.notification.successDescription':
    'Stock Correction removed.',
};
